export default __webpack_public_path__ + "static/media/mynote.1cdf7f32.png";